module.exports = __webpack_public_path__ + "img/error-submit.1017d3c.webp";